import { types } from '../../../constants/ActionTypes'

const initialState = {
  auth0: undefined,
  user: null,
  isAuthStateChange: false,
}

const authentication = (state = initialState, action) => {
  switch (action.type) {
    case types.auth0.CREATED_AUTH0_CLIENT:
      return {
        ...state,
        auth0: action.auth0
      }
    case types.auth0.CHANGED_AUTH_STATE:
      return {
        ...state,
        user: action.user,
        isAuthStateChange: true,
      }
    default:
      return state
  }
}

export default authentication


// WEBPACK FOOTER //
// ./src/reducers/Common/Authentication/Authentication.js